import { readFormValues, removeFormValues, writeFormValues } from "../../utils/storage";

//删除本地缓存为该formID的表单缓存
export const deleteFormData = (formId?: number | string) => {
  if (!formId) {
    return
  }
  const parsed = readFormValues()
  if (parsed.length > 1) {
    const index = parsed.findIndex((item: any) => {
      return item.formId === Number(formId)
    })
    if (index !== -1) {
      parsed.splice(index, 1)
    }
    writeFormValues(parsed)
  } else {
    removeFormValues()
  }
}

//处理group类型规则
export const dealValidationRulesGroup = (data: any) => {
    let validationRules: any = []
    data.forEach((item: any) => {
        if (item.children) {
            let _data = dealValidationRulesGroup(item.children)
            validationRules = [...validationRules, ..._data]
        } else {
            validationRules.push(item)
        }
    });
    return validationRules
}

export const filterNoVaildData = (validationRulesAll: any, savedValues: any) => {
    const vaildDataArr: any = [];
    validationRulesAll.forEach((item: any) => {
        if (item.display && item.display.type === 'ValueCascade') {

            if (item.display.condition === 'eq') {
                //当前选中表单已存的value
                let currentItem = savedValues.find((i: any) => {
                    return i.dataCode == item.display.target
                });
                if (currentItem) {
                    if ((currentItem.value && currentItem.value.indexOf(item.display.rule) !== -1) || (currentItem.value && currentItem.value === item.display.rule)) {
                        vaildDataArr.push(item)
                    }
                }
            }
            // else if (item.display.condition === 'andEq') {
            //     let judgeArr = [];
            //     for (let i = 0; i < item.display.target.length; i++) {
            //         let findedItem = savedValues.find((valueItem: any) => {
            //             return valueItem.dataCode === item.display.target[i]
            //         });
            //         if (findedItem) {
            //             if (findedItem.value instanceof Array) {
            //                 if (findedItem.value.indexOf(item.display.rule[i]) === -1) {
            //                     judgeArr.push(false);
            //                 }
            //                 else {
            //                     judgeArr.push(true);
            //                 }
            //             }
            //             else {
            //                 if (findedItem.value !== item.display.rule[i]) {
            //                     judgeArr.push(false);
            //                 }
            //                 else {
            //                     judgeArr.push(true);
            //                 }
            //             }
            //         }
            //         else {
            //             judgeArr.push(false)
            //         }
            //     }
            //     if (judgeArr.every(item => {
            //         if (item === true) {
            //             return true
            //         }
            //     })) {
            //           vaildDataArr.push(item)
            //     }
            // }
            // else if (item.display.condition === 'orEq') {
            //     let judgeArr = [];
            //     for (let i = 0; i < item.display.target.length; i++) {
            //         let findedItem = savedValues.find((valueItem: any) => {
            //             return valueItem.dataCode === item.display.target[i]
            //         });
            //         if (findedItem) {
            //             if (findedItem.value instanceof Array) {
            //                 if (findedItem.value.indexOf(item.display.rule[i]) === -1) {
            //                     judgeArr.push(false);
            //                 }
            //                 else {
            //                     judgeArr.push(true);
            //                 }
            //             }
            //             else {
            //                 if (findedItem.value !== item.display.rule[i]) {
            //                     judgeArr.push(false);
            //                 }
            //                 else {
            //                     judgeArr.push(true);
            //                 }
            //             }
            //         }
            //         else {
            //             judgeArr.push(false)
            //         }
            //     }
            //     if (judgeArr.indexOf(true) !== -1) {
            //          vaildDataArr.push(item)
            //     }
            // }

        } else {
            vaildDataArr.push(item)
        }
    });

    return vaildDataArr;
}

// 组装字段元素ID
export const takeFieldId = (dataCode: string, controlId = 'None')=> {
  return ['FieldCom', controlId, dataCode].join('-')
}

// 组件字段操作元素ID
export const takeActionId = (dataCode: string, controlId = 'None')=> {
  return ['ActionView', controlId, dataCode].join('-')
}
